export default "__VITE_ASSET__BRkhskdN__"